import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';

import { CTA } from '../components/Layout/CTA';

import '../components/GlobalStyle.css';

import BlogContent from '../components/KnowledgeCenterComponents/BlogContent';


const KnowledgeCenter = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Resources | Knowledge Center</title>
                <link rel="canonical" href="https://bestpayment.solutions/knowledge-center" />
            </Helmet>
            <Navigation />
            <Container fluid>
                <Row className='justify-content-center'>
                    <Col>
                        <BlogContent />
                    </Col>
                </Row>
            </Container>
            <Container fluid className='bg-sky-tint-3 py-5'>
                <CTA />
            </Container>
            <Footer />
        </>
    );
}

export default KnowledgeCenter;